<template>
    <span class="product-sparkle">
        <MaltImg class="product-sparkle--sm" src="/cms-front/sparkle-sm.png?vh=ca8631" alt="Sparkle small" width="18" />
        <MaltImg class="product-sparkle--md" src="/cms-front/sparkle-md.png?vh=54e8e4" alt="sparkle medium" width="30" />
        <MaltImg class="product-sparkle--lg" src="/cms-front/sparkle-lg.png?vh=921011" alt="sparkle large" width="48" />
    </span>
</template>

<script lang="ts" setup>
    import {MaltImg} from '#components';
</script>

<style lang="scss">
    $ref-width: 70;

    .product-sparkle {
        position: relative;
        display: inline-block;
        width: 70px;
        aspect-ratio: 1;

        > img {
            position: absolute;
            transform: scale(0);
        }

        &--sm {
            width: calc(18 / $ref-width) * 100%;
            top: calc(52 / $ref-width) * 100%;
            left: calc(8 / $ref-width) * 100%;
        }
        &--md {
            width: calc(30 / $ref-width) * 100%;
            top: 0;
            left: calc(-4 / $ref-width) * 100%;
        }
        &--lg {
            width: calc(48 / $ref-width) * 100%;
            top: calc(18 / $ref-width) * 100%;
            left: calc(19 / $ref-width) * 100%;
        }

        &.animate {
            > img {
                transition: transform var(--ai-transition-duration) var(--ai-transition-timing-function);
                transform: scale(1);
            }
            .product-sparkle--sm {
                transition-delay: 0.2s;
            }
            .product-sparkle--lg {
                transition-delay: 0.6s;
            }
        }
    }
</style>
